import { moment, TimeFormat } from '@feathr/hooks';

enum EDateStr {}
export type DateStr = string & EDateStr;

export function toDateStr(date: Date | moment.Moment | string): DateStr {
  const validDateRegex = /^\d{4}-\d{2}-\d{2}$/;
  let dateFormatted;
  if (typeof date === 'string') {
    dateFormatted = moment.utc(date, TimeFormat.isoDate).format(TimeFormat.isoDate);
  } else {
    dateFormatted = moment.utc(date).format(TimeFormat.isoDate);
  }
  if (validDateRegex.exec(dateFormatted)) {
    return dateFormatted as DateStr;
  }
  throw new Error(`Could not cast value to DateStr. Value provided: ${date}`);
}

enum EDateTimeStr {}
export type DateTimeStr = string & EDateTimeStr;

export function toDateTimeStr(datetime: Date | moment.Moment | string): DateTimeStr {
  let datetimeFormatted;
  if (typeof datetime === 'string') {
    datetimeFormatted = moment(datetime, moment.ISO_8601).format(TimeFormat.isoDateTime);
  } else {
    datetimeFormatted = moment(datetime).format(TimeFormat.isoDateTime);
  }
  if (moment(datetimeFormatted, moment.ISO_8601).isValid()) {
    return datetimeFormatted as DateTimeStr;
  }
  throw new Error(`Could not cast value to DateTimeStr. Value provided: ${datetime}`);
}
